'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentCreatePurchaseOrderRequest(number, recipient, currency, lineItems, documentaryCredit, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, importer, consignee, harmonizedSystemCode) {
  this.a80 = null;
  this.a85 = null;
  this.a7V = null;
  this.a7Z = null;
  this.a7W = null;
  this.a84 = null;
  this.a83 = null;
  this.a81 = null;
  this.a82 = null;
  this.a7Y = null;
  this.a7U = null;
  this.a7X = null;
  this.a80 = number;
  this.a85 = recipient;
  this.a7V = currency;
  this.a7Z = lineItems;
  this.a7W = documentaryCredit;
  this.a84 = placeOfReceipt;
  this.a83 = placeOfLoading;
  this.a81 = placeOfDelivery;
  this.a82 = placeOfDischarge;
  this.a7Y = importer;
  this.a7U = consignee;
  this.a7X = harmonizedSystemCode;
}
export { $c_Lapp_data_AppDocumentCreatePurchaseOrderRequest as $c_Lapp_data_AppDocumentCreatePurchaseOrderRequest };
$p = $c_Lapp_data_AppDocumentCreatePurchaseOrderRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentCreatePurchaseOrderRequest;
/** @constructor */
function $h_Lapp_data_AppDocumentCreatePurchaseOrderRequest() {
}
export { $h_Lapp_data_AppDocumentCreatePurchaseOrderRequest as $h_Lapp_data_AppDocumentCreatePurchaseOrderRequest };
$h_Lapp_data_AppDocumentCreatePurchaseOrderRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentCreatePurchaseOrderRequest)) {
    if ((this.a80 === x$0.a80)) {
      var x = this.a85;
      var x$2 = x$0.a85;
      var $x_10 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$3 = this.a7V;
      var x$4 = x$0.a7V;
      var $x_9 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$5 = this.a7Z;
      var x$6 = x$0.a7Z;
      var $x_8 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$7 = this.a7W;
      var x$8 = x$0.a7W;
      var $x_7 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$9 = this.a84;
      var x$10 = x$0.a84;
      var $x_6 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$11 = this.a83;
      var x$12 = x$0.a83;
      var $x_5 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$13 = this.a81;
      var x$14 = x$0.a81;
      var $x_4 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$15 = this.a82;
      var x$16 = x$0.a82;
      var $x_3 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$17 = this.a7Y;
      var x$18 = x$0.a7Y;
      var $x_2 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$19 = this.a7U;
      var x$20 = x$0.a7U;
      var $x_1 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$21 = this.a7X;
      var x$22 = x$0.a7X;
      return ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 12;
});
$p.t = (function() {
  return "AppDocumentCreatePurchaseOrderRequest";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.a80;
      break;
    }
    case 1: {
      return this.a85;
      break;
    }
    case 2: {
      return this.a7V;
      break;
    }
    case 3: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.a7Z);
      break;
    }
    case 4: {
      return this.a7W;
      break;
    }
    case 5: {
      return this.a84;
      break;
    }
    case 6: {
      return this.a83;
      break;
    }
    case 7: {
      return this.a81;
      break;
    }
    case 8: {
      return this.a82;
      break;
    }
    case 9: {
      return this.a7Y;
      break;
    }
    case 10: {
      return this.a7U;
      break;
    }
    case 11: {
      return this.a7X;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "recipient";
      break;
    }
    case 2: {
      return "currency";
      break;
    }
    case 3: {
      return "lineItems";
      break;
    }
    case 4: {
      return "documentaryCredit";
      break;
    }
    case 5: {
      return "placeOfReceipt";
      break;
    }
    case 6: {
      return "placeOfLoading";
      break;
    }
    case 7: {
      return "placeOfDelivery";
      break;
    }
    case 8: {
      return "placeOfDischarge";
      break;
    }
    case 9: {
      return "importer";
      break;
    }
    case 10: {
      return "consignee";
      break;
    }
    case 11: {
      return "harmonizedSystemCode";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentCreatePurchaseOrderRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iF)));
}
export { $isArrayOf_Lapp_data_AppDocumentCreatePurchaseOrderRequest as $isArrayOf_Lapp_data_AppDocumentCreatePurchaseOrderRequest };
var $d_Lapp_data_AppDocumentCreatePurchaseOrderRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentCreatePurchaseOrderRequest, "app.data.AppDocumentCreatePurchaseOrderRequest", ({
  iF: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentCreatePurchaseOrderRequest as $d_Lapp_data_AppDocumentCreatePurchaseOrderRequest };
//# sourceMappingURL=app.data.-App-Document-Create-Purchase-Order-Request.js.map
